(function () {
  'use strict';

  var FAQ_HEADING_TEXT = 'ofte stilte spørsmål';

  function normalize(s) {
    return s.trim().toLowerCase().replace(/[?:.!]+$/, '');
  }

  function isFaqHeading(el) {
    return el && el.tagName === 'H2' && normalize(el.textContent) === FAQ_HEADING_TEXT;
  }

  function enhanceHeading(faqHeading) {
    if (faqHeading.dataset.faqInitialized === 'true') return;
    faqHeading.dataset.faqInitialized = 'true';
    faqHeading.classList.add('faq-section-heading');

    var list = document.createElement('div');
    list.className = 'faq-list';

    var node = faqHeading.nextElementSibling;
    var idBase = 'faq-' + Math.random().toString(36).slice(2, 8);
    var index = 0;

    while (node && node.tagName === 'H3') {
      var question = node;
      var answer = node.nextElementSibling;
      var next = answer ? answer.nextElementSibling : null;

      if (!answer || answer.tagName !== 'P') {
        node = next;
        continue;
      }

      var item = document.createElement('div');
      item.className = 'faq-item';

      var btnId = idBase + '-q-' + index;
      var panelId = idBase + '-a-' + index;
      index++;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'faq-question';
      btn.id = btnId;
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', panelId);

      var label = document.createElement('span');
      label.className = 'faq-question-text';
      label.textContent = question.textContent.trim();
      btn.appendChild(label);

      var icon = document.createElement('span');
      icon.className = 'faq-icon';
      icon.setAttribute('aria-hidden', 'true');
      btn.appendChild(icon);

      var panel = document.createElement('div');
      panel.className = 'faq-answer';
      panel.id = panelId;
      panel.setAttribute('role', 'region');
      panel.setAttribute('aria-labelledby', btnId);

      var inner = document.createElement('div');
      inner.className = 'faq-answer-inner';
      inner.innerHTML = answer.innerHTML;
      panel.appendChild(inner);

      item.appendChild(btn);
      item.appendChild(panel);
      list.appendChild(item);

      btn.addEventListener('click', (function (el) {
        return function () {
          var open = el.classList.toggle('is-open');
          el.querySelector('.faq-question').setAttribute(
            'aria-expanded',
            open ? 'true' : 'false'
          );
        };
      })(item));

      question.remove();
      answer.remove();
      node = next;
    }

    if (list.children.length === 0) return;
    faqHeading.parentNode.insertBefore(list, faqHeading.nextSibling);
  }

  function run(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var headings = scope.querySelectorAll('h2');
    for (var i = 0; i < headings.length; i++) {
      if (isFaqHeading(headings[i])) enhanceHeading(headings[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document);
    });
  } else {
    run(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    run(e.target);
  });
})();
